<div class="position-relative  pb-3">
    <div class="d-flex ">
        <ng-container *ngFor="let areaA of line.areaA">
            <div *ngIf="!areaA.isHidden" class="border-2 border-black border">
                <div class="text-secondary text-center" [ngStyle]="{'min-width.px': width[areaA.x -1]}">
                    {{ getPositionLabel(areaA.x, 1) }}
                </div>
                <div *ngIf="areaA.station" class="d-flex justify-content-center  mb-2 " style="gap: 4px">

                    <ng-container *ngFor="let station of areaA.station">
                        <div class="border border-1 border-black h-100" style="width: 280px; ">
                            <avs-route-stations-line-param [routeStation]="station"></avs-route-stations-line-param>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>

    <div class=" bg-secondary position-absolute w-100" style="padding-top: 2px; left: 8px;  right: 8px;">
        <div class="avs-schema-road">
            <div class="avs-schema-road-middle-strip"></div>
            <div class="avs-schema-road-stripe"></div>
            <div class="avs-schema-road-middle-strip"></div>
            <div class="avs-schema-road-end"></div>
        </div>
    </div>
    <div class="d-flex " style="padding-top: 83px;">
        <ng-container *ngFor="let areaB of line.areaB">
            <div *ngIf="!areaB.isHidden" class="border-2 border-black border">
                <div class="text-secondary text-center" [ngStyle]="{'min-width.px': width[areaB.x -1]}">
                    {{ getPositionLabel(areaB.x, 2) }}
                </div>
                <div *ngIf="areaB.station" class="d-flex justify-content-center   mb-2" style="gap: 4px">
                    <ng-container *ngFor="let station of areaB.station">
                        <div class="border border-1 border-black h-100 " style="width: 280px;">
                            <avs-route-stations-line-param [routeStation]="station"></avs-route-stations-line-param>

                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>